/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderType
 */
export interface OrderType {
    /**
     * 订单类型名称（韩文）
     * @type {string}
     * @memberof OrderType
     */
    orderTypeNameKr?: string;
    /**
     * 订单类型名称（中文）
     * @type {string}
     * @memberof OrderType
     */
    orderTypeNameCn?: string;
    /**
     * 订单类型编码
     * @type {number}
     * @memberof OrderType
     */
    orderTypeCode?: number;
}

/**
 * Check if a given object implements the OrderType interface.
 */
export function instanceOfOrderType(value: object): value is OrderType {
    return true;
}

export function OrderTypeFromJSON(json: any): OrderType {
    return OrderTypeFromJSONTyped(json, false);
}

export function OrderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderType {
    if (json == null) {
        return json;
    }
    return {
        
        'orderTypeNameKr': json['orderTypeNameKr'] == null ? undefined : json['orderTypeNameKr'],
        'orderTypeNameCn': json['orderTypeNameCn'] == null ? undefined : json['orderTypeNameCn'],
        'orderTypeCode': json['orderTypeCode'] == null ? undefined : json['orderTypeCode'],
    };
}

export function OrderTypeToJSON(json: any): OrderType {
    return OrderTypeToJSONTyped(json, false);
}

export function OrderTypeToJSONTyped(value?: OrderType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderTypeNameKr': value['orderTypeNameKr'],
        'orderTypeNameCn': value['orderTypeNameCn'],
        'orderTypeCode': value['orderTypeCode'],
    };
}

